import { Stack, Typography } from '@mui/material';
import { Fragment, ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  descriptions?: ReactNode[];
}

export const StepHeader = (props: Props) => {
  return (
    <Stack gap={1}>
      {props.title && (
        <Typography variant="h4" color="text.primary">
          {props.title}
        </Typography>
      )}
      <Stack gap={1}>
        {props.descriptions?.map((description, index) =>
          typeof description === 'string' ? (
            <Typography key={index} variant="body1">
              {description}
            </Typography>
          ) : (
            <Fragment key={index}>{description}</Fragment>
          )
        )}
      </Stack>
    </Stack>
  );
};
